/**
 * Firebase-Zugangsdaten – die EINZIGE Stelle, an der sie gelesen werden.
 *
 * Die Werte stehen in `leadsheet/.env` (Vorlage: `.env.example`). Vite baut
 * sie beim `npm run build` fest in die App ein. Das ist bei Firebase
 * ausdruecklich so vorgesehen: diese Werte sind KEIN Geheimnis, sie sagen
 * nur, welches Projekt gemeint ist. Geschuetzt werden die Daten durch die
 * Regeln in `firestore.rules`, nicht dadurch, dass niemand den Schluessel
 * kennt.
 *
 * Fehlt der apiKey, laeuft die App wie frueher: ohne Anmeldung, alles lokal.
 */
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
};

/**
 * Lokale Firebase-Emulatoren statt des echten Projekts (nur zum Testen).
 * In .env: VITE_FIREBASE_EMULATOR=true
 */
export const useEmulator = import.meta.env.VITE_FIREBASE_EMULATOR === 'true';

/**
 * App Check (reCAPTCHA v3) gegen Bots: Nur Anfragen aus unserer echten App
 * bekommen ein Pruef-Token, das Firebase verlangt, sobald im Dashboard
 * „Erzwingen“ an ist (SECURITY.md, S5). Der Website-Schluessel ist
 * oeffentlich (steht ohnehin in jeder Seite) – der geheime Schluessel liegt
 * nur in der Firebase-Konsole. Leer = kein App Check (wie bisher).
 */
export const appCheckSiteKey = (() => {
  const v = String(import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? '').trim();
  return /^[\w-]{20,100}$/.test(v) ? v : '';
})();

/** true, sobald ein Firebase-Projekt eingetragen ist. */
export const firebaseEnabled = firebaseConfig.apiKey !== '' && firebaseConfig.projectId !== '';

/**
 * Welche Anmeldewege angeboten werden. Zum Abschalten auf "false" setzen –
 * und in der Firebase-Konsole unter Authentication ebenfalls deaktivieren.
 */
export const LOGIN_METHODS = {
  emailPassword: true,
  google: true,
};
